import React from 'react';
import { logger } from 'services';
import { SlackAuthenticationProps } from './authenticate.types';
import { Connected } from './connected';
import { Disconnected } from './disconnected';

export const SlackAuthentication = ({
  oauthUrl,
  isConnecting,
  isDisconnecting,
  authenticatedBy,
  isConnected = false,
  handleDisconnect,
}: SlackAuthenticationProps): JSX.Element => {
  if (isConnected) {
    return (
      <Connected
        handleDisconnect={handleDisconnect}
        isDisconnecting={isDisconnecting}
        authenticatedBy={authenticatedBy}
      />
    );
  }
  if (oauthUrl) {
    return <Disconnected oauthUrl={oauthUrl} loading={isConnecting} />;
  }

  logger.warn('Unable to load slack authentication ui');

  return <></>;
};
